import { NavListItem } from "./charityData";

export const MajorCategories:Array<NavListItem> = [
    { href: '/categories/view/animals', name: 'Animals' },
    { href: '/categories/view/anti-fracking', name: 'Anti-Fracking' },
    { href: '/categories/view/arts-and-culture', name: 'Arts & Culture' },
    { href: '/categories/view/breast-cancer', name: 'Breast Cancer' },
    { href: '/categories/view/bullying', name: 'Bullying' },
    { href: '/categories/view/cancer', name: 'Cancer' },
    { href: '/categories/view/children-and-youth', name: 'Children & Youth' },
    { href: '/categories/view/civil-rights', name: 'Civil Rights' },
    { href: '/categories/view/climate-change', name: 'Climate Change' },
    { href: '/categories/view/crime-and-law', name: 'Crime & Law' },
    { href: '/categories/view/disabilities', name: 'Disabilities' },
    { href: '/categories/view/disaster-aid', name: 'Disaster Aid' },
    { href: '/categories/view/economic-development', name: 'Economic Development' },
    { href: '/categories/view/education', name: 'Education' },
    { href: '/categories/view/environment', name: 'Environment' },
    { href: '/categories/view/food', name: 'Food' },
    { href: '/categories/view/health', name: 'Health' },
    { href: '/categories/view/homeless-and-housing', name: 'Homeless & Housing' },
    { href: '/categories/view/human-services', name: 'Human Services' },
  ];
  